import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText} from "reactstrap";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import AppEditIcon from "../../../media/assets/AppEditIcon.mjs";
import "./EditMessage.css";
import CheckIcon from "../../../media/assets/CheckIcon.mjs";
import EyeIcon from "../../../media/assets/EyeIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import BLib from "../BLib.mjs";
import MailIcon from "../../../media/assets/MailIcon.mjs";
import UserIcon from "../../../media/assets/UserIcon.mjs";

const prefix = "EditMessage";

const EditMessage = class extends Component {
	constructor(props) {
		super(props);
		const minDate = new Date();
		const maxDate = new Date();
		maxDate.setDate(maxDate.getDate() + 180);
		const val = props.value?.axle ? Glob.clone(props.value) : {};
		if ( val.expire ) {
			if ( typeof val.expire === "number" ) {
				const defDate = new Date( val.expire );
				val.expire = defDate.toISOString().split("T")[0];
			} else {
				val.expire = val.expire.replace(/[T ].*/, "");
			}
		} else {
			const defDate = new Date();
			defDate.setDate(defDate.getDate() + 7);
			val.expire = defDate.toISOString().split("T")[0];
		}
		if ( ! val.axle ) val.axle = props.axle || "offro";
		delete val.meta;
		this.state = {
			lang: Glob.getLanguage(),
			v: val,
			minDate: minDate.toISOString().split("T")[0],
			maxDate: maxDate.toISOString().split("T")[0],
		}
		this.uid = Glob.generateUid(prefix);
		this.setVal = this.setVal.bind(this);
		this.save = this.save.bind(this);
		this.cancel = this.cancel.bind(this);
	}
	setVal(name,value){
		if ( name?.target ) {
			value = name.target.value;
			name = name.target.name;
		}
		const v = this.state.v || {};
		if ( typeof value === 'undefined') {
			delete v[name];
		} else {
			if ( typeof value === 'string') value = value.replace(/\t+/g, " ");
			v[name] = value;
		}
		this.setState({
			v:v,
			valid: !! ((v.subject||'').trim() && (v.body||'').trim())
		});
	}
	save() {
		const v = this.state.v;
		v.subject = v.subject.trim();
		v.body = v.body.trim();
		this.setState({ saving: true }, ()=>{
			appLib.api('bacheca/save-message', { message: this.state.v }).then(() => {
				BLib.restartPoll();
				this.cancel();
			}).catch((err) => {
				console.error(err);
			}).finally(()=>{
				this.setState({ saving: false });
			})
		});
	}
	cancel() {
		Glob.trigger('MessaggeEdit', false );
	}
	render() {
		return (
			<Form
				autoComplete={"off"}
				className={prefix}
				id={this.uid}
				onSubmit={ event => {
					event.preventDefault();
					if ( this.state.saving ) return;
					if ( this.state.valid ) this.save();
				}}
			>
			<div className={"MessaggiAreaHeader"}>
					<div>
						<AppEditIcon />
						<h2>
							<TextLabel value={this.state.v.axle === 'cerco' ? "Wanted" : "Offering"} />
						</h2>
					</div>
					<ButtonGroup>
						<Button
							color={"warning"}
							type="reset"
							onClick={  this.cancel}
						>
							<i>
								<CloseIcon />
							</i>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
						</Button>
						<Button
							type="submit"
							color={"primary"}
							disabled={ !! ( ! this.state.valid || this.state.saving) }
						>
							<b>
								<TextLabel value={"Save"} />
							</b>
							<i>
								<CheckIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
				<div className={"Fields"}>
					<h4>
						<TextLabel value={this.state.v?.id ? 'Edit' : 'New'} />
					</h4>
					<hr />
					<Input
						autoFocus={true}
						name={"subject"}
						invalid={ ! (this.state.v?.subject || '').trim()}
						value={ this.state.v?.subject || '' }
						onChange={ this.setVal }
						placeholder={ Glob.label("Subject") }
						maxLength={ 96 }
					/>
					<Input
						type={"textarea"}
						name={"body"}
						invalid={ ! (this.state.v?.body || '').trim()}
						value={ this.state.v?.body || ''}
						onChange={ this.setVal }
						placeholder={ Glob.label("Details") }
						maxLength={ 800 }
					/>
					<hr />
					<InputGroup>
						<InputGroupText>
							<TextLabel value={"Expires on"} />:
						</InputGroupText>
						<Input
							lang={ Glob.getLanguageLong() }
							type={"date"}
							name={"expire"}
							min={ this.state.minDate }
							max={ this.state.maxDate }
							value={ this.state.v?.expire }
							onChange={ this.setVal }
						/>
					</InputGroup>
					<hr />
					{ this.state.lang === 'it' ? (
						<div>I dettagli sono visibili da:</div>
					) : (
						<div>Details can be read by:</div>
					)}
					<ButtonGroup
						className={"btn-icon w-100"}
					>
						<Button
							color={! this.state.v?.private ? "primary" : "secondary"}
							onClick={ ()=>{ this.setVal( "private", false ); } }
						>
							<i><EyeIcon /></i>
							<b>
								<TextLabel value={"Everyone on the web"} />
							</b>
						</Button>
						<Button
							color={this.state.v?.private ? "primary" : "secondary"}
							onClick={ ()=>{ this.setVal( "private", true ); } }
						>
							<b>
								<TextLabel value={"Registered users"} />
							</b>
							<i><UserIcon /></i>
						</Button>
					</ButtonGroup>
					<hr />
					{ this.state.lang === 'it' ? (
						<div>Gli utenti autenticati possono rispondere via mail?</div>
					) : (
						<div>Authenticated user can reply via mail?</div>
					)}
					<ButtonGroup
						className={"btn-icon w-100"}
					>
						<Button
							color={! this.state.v?.nomail ? 'primary' : 'secondary'}
							onClick={ ()=>{ this.setVal( "nomail", false ); } }
						>
							<i><MailIcon /></i>
							<b>
								{ this.state.lang === 'it' ? 'Sì, certo' : 'Yes, of course'}
							</b>
						</Button>
						<Button
							color={this.state.v?.nomail ? 'primary' : 'secondary'}
							onClick={ ()=>{ this.setVal( "nomail", true ); } }
						>
							<b>
								{ this.state.lang === 'it' ? 'Nessuna email' : 'No mail, thanks!'}
							</b>
							<i><CloseIcon /></i>
						</Button>
					</ButtonGroup>
					<hr />
				</div>
			</Form>
		)
	}
}

export default EditMessage;
